export const CONTRACT_VALIDITY_KIND = {
  CONTINUOUS: 'CONTINUOUS',
  FIXED_CONTRACT_LENGTH: 'FIXED_CONTRACT_LENGTH',
  FIXED_TERM: 'FIXED_TERM',
  STARTING_PERIOD: 'STARTING_PERIOD',
}
